
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import classnames from 'classnames'
import Icon from 'components/Icon'
import ChannelIcon from 'components/ChannelIcon'
import take from 'lodash/take'
import {openChannelSelectorModal} from 'redux/modules/ui/modal/actions'

class ChannelGroupSelector extends React.Component {
  static propTypes = {
    groups: PropTypes.array,
    channelTypes: PropTypes.array,
    selected: PropTypes.array,
    types: PropTypes.array,
    onSelect: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    isSingle: PropTypes.bool,
    openChannelSelectorModal: PropTypes.func
  }

  render() {
    const {className, selected, disabled} = this.props
    const classNames = classnames('channel-group-selector', className, {
      'is-empty': !selected || !selected.length,
      'is-one': selected && selected.length === 1,
      'is-big': selected && selected.length > 1 && selected.length <= 4,
      'is-small': selected && selected.length > 4 && selected.length <= 9,
      'is-tiny': selected && selected.length > 9,
      'is-disabled': disabled
    })

    return (
      <div className={classNames} onClick={this.onShowSelector}>
        {this.renderSelectedChannels()}
      </div>
    )
  }

  renderSelectedChannels() {
    const {selected} = this.props

    if (!selected || selected.length === 0) {
      return <Icon size='14' name='flake' className='channel-group-selector_any' />
    }

    const length = selected.length

    if (length === 1) return this.renderOneIcon()
    if (length > 1 && length <= 4) return this.renderBigIcons()
    if (length > 4 && length <= 9) return this.renderSmallIcons()

    return this.renderSmallIcons(true)
  }

  renderOneIcon() {
    const {selected} = this.props
    const item = selected[0]
    const {channelGroup, channel} = item

    if (channelGroup && channel) {
      return (
        <ChannelIcon
          className='channel-group-selector_one_channel'
          name={channel}
          group={channelGroup}
          size='12px'
          active
        />
      )
    } else {
      const classNames = classnames('channel-group-selector_one_group', {
        'channel-group-selector_item': true,
        [`is-${channelGroup}`]: true
      })
      return (
        <div className={classNames} />
      )
    }
  }

  renderBigIcons() {
    const {selected} = this.props

    return selected.map((item, index) => {
      const {channelGroup, channel} = item
      if (channelGroup && channel) {
        return (
          <ChannelIcon
            className='channel-group-selector_big_channel'
            name={channel}
            group={channelGroup}
            size='4px'
            active
            key={index}
          />
        )
      } else {
        const classNames = classnames('channel-group-selector_big_group', {
          'channel-group-selector_item': true,
          [`is-${channelGroup}`]: true
        })
        return (
          <div className={classNames} key={index} />
        )
      }
    })
  }

  renderSmallIcons(isTiny) {
    const {selected} = this.props

    return take(selected, 16).map((item, index) => {
      const {channelGroup} = item
      const mainClass = isTiny ? 'channel-group-selector_tiny' : 'channel-group-selector_small'
      const classNames = classnames(mainClass, {
        'channel-group-selector_item': true,
        [`is-${channelGroup}`]: true
      })
      return (
        <div className={classNames} key={index} />
      )
    })
  }

  onShowSelector = () => {
    const {
      groups,
      channelTypes,
      selected,
      types,
      onSelect,
      openChannelSelectorModal,
      disabled,
      isSingle
    } = this.props

    if (disabled) return null

    openChannelSelectorModal({
      groups,
      channelTypes,
      selected,
      types,
      onSelect,
      isSingle
    })
  }
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {
  openChannelSelectorModal
})(ChannelGroupSelector)



// WEBPACK FOOTER //
// ./client/containers/ChannelGroupSelector/index.js